export default {"src":"/_next/static/media/badge-appstore-en.1b78defa.svg","height":40,"width":120,"blurWidth":0,"blurHeight":0};